import { render, staticRenderFns } from "./VerificationComponent.vue?vue&type=template&id=5aaef48a&"
import script from "./VerificationComponent.vue?vue&type=script&lang=js&"
export * from "./VerificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports